<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Agentic AI in the SDLC
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/whitepaper/agentic-ai-in-sdlc/agenic-ai-in-sdlc-bannerimg.gif"
            alt="Agentic-AI-in-SDLC" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Agentic AI transforms the SDLC by enabling autonomous, proactive, and learning-driven agents to
          accelerate full-stack development across multi-cloud environments.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Integration spans planning, coding, testing, deployment, monitoring, and optimization,
          streamlining workflows, enhancing quality, and reducing time-to-market.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Key benefits include cost optimization, improved security and compliance, knowledge preservation,
          and simplified multi-cloud management.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Successful adoption requires phased implementation, robust data infrastructure, human-agent
          collaboration, and explainable AI practices.</p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Agentic AI Characteristics:</strong> Autonomy, goal-orientation, proactivity, continuous
          learning, and collaboration make it ideal for modern SDLC.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Full-Stack Acceleration:</strong> Agents unify frontend, backend, and infrastructure
          tasks, enabling faster prototyping, experimentation, and deployment.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Multi-Cloud Optimization:</strong> Agentic AI intelligently manages resources across
          diverse cloud environments while maintaining compliance and security.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Human-AI Collaboration:</strong> Engineers transition from coding to architecting
          AI-driven workflows, focusing on strategic problem-solving.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Challenges:</strong> Integration complexity, trust, explainability, data requirements,
          security, ethics, and vendor lock-in must be addressed.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Adoption Strategy:</strong> Start small, prioritize collaboration, invest in data
          infrastructure, ensure security, and iteratively improve agentic capabilities.</p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      <i class="ri-download-2-line"></i> Download the Complete White Paper
    </button>
  </div>
</section>
<!-- Relavent Article -->
<app-relevant-whitepaper></app-relevant-whitepaper>


<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Download White Paper</h3>
      <p>Fill in your details to receive the white paper.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>